// Morehouse College's majors (#2739). Read on 2026-10-01 from the official
// 2026-2027 Morehouse College Academic Catalog, Academic Departments and
// Programs (Majors and Minors) (catalog.morehouse.edu, the Acalog catalog that
// morehouse.edu/academics/college-catalog links): every bachelor's degree
// listed under "Major" for each department or program, in the catalog's own
// words, with Bachelor of Arts written B.A. and Bachelor of Science B.S. The
// catalog says Morehouse "offers 34 disciplinary or interdisciplinary majors";
// its list names 39 degree programs because some majors come as both a B.A.
// and a B.S., Business Administration is also offered through Morehouse
// Online, and the Dual Degree Engineering Program has two options. The
// Cinema, Television and Emerging Studies name is the catalog's degree line
// (its department is Cinema, Television, and Emerging Media Studies). Minors
// and minor-only programs are left out.
const majors = {
    "slug": "morehouse-college",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program listed as a major in Morehouse's official 2026-2027 Academic Catalog. Minors are left out.",
    "groups": [
        {
            "name": "Majors, A to Z",
            "source": {
                "label": "Morehouse College Academic Catalog 2026-2027, Academic Departments and Programs",
                "url": "https://catalog.morehouse.edu/content.php?catoid=7&navoid=313"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Management Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Physics, Mathematics or Chemistry (Dual Degree Engineering, Option II)",
                    "degree": "B.S."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration (Morehouse Online)",
                    "degree": "B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chinese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Cinema, Television and Emerging Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Dance Performance and Choreography",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education Studies (Non-Certification)",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "General Science (Dual Degree Engineering, Option I)",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism in Sports, Culture and Social Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Kinesiology - Sports Studies & Physical Education",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Secondary Education and Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theater and Performance",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
